/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Inventory_By_PromoInputs */



/**
* | output |
* | --- |
* | "By promo" |
*
* @param {Promo_Inventory_By_PromoInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_inventory_by_promo = /** @type {((inputs?: Promo_Inventory_By_PromoInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Inventory_By_PromoInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Par promo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por promo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Por promo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per promo")
	return /** @type {LocalizedString} */ ("By promo")
});